import { render, staticRenderFns } from "./groupSet.vue?vue&type=template&id=85d3d552&scoped=true&"
import script from "./groupSet.vue?vue&type=script&lang=ts&"
export * from "./groupSet.vue?vue&type=script&lang=ts&"
import style0 from "./groupSet.vue?vue&type=style&index=0&id=85d3d552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85d3d552",
  null
  
)

export default component.exports